import axios from 'axios';
import { getItem } from '../../utils/localStorage';

export const updatePassword = async (payload) => {
    const { data } = await axios.put(`${Env.API_URL}/auth/changepassword`, payload);
    return data;
};

export const deleteMembershipDelete = async () => {
    const userData = getItem('user');
    const { data } = await axios.delete(`${Env.API_URL}/user-profile`, {
        headers: {
            Authorization : `Bearer ${userData.accessToken}`,
        },
    });
    return data;
};
